import { useState, useEffect } from 'react';
import { client } from '../sanity/client';

export function useSideProjects() {
  const [sideProjects, setSideProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client
      .fetch(`*[_type == "sideProject"] | order(order asc) {
        _id,
        title,
        projectTypes,
        image,
        "imageExtension": image.asset->extension,
        "imageUrl": image.asset->url,
        description,
        content[] {
          ...,
          _type == "image" => {
            ...,
            "url": asset->url
          },
          _type == "imageCarousel" => {
            ...,
            images[] {
              ...,
              "url": asset->url
            }
          },
          _type == "video" => {
            ...,
            "url": file.asset->url
          }
        },
        links
      }`)
      .then(data => {
        setSideProjects(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching side projects:', err);
        setLoading(false);
      });
  }, []);

  return { sideProjects, loading };
}
